// === wizardStepType.js START ====================================================================

wizardSteps["discussion"] = {
    templateName: "#wizardStepDiscussion",
    onInit: function () {
        self = this;
        Handlebars.registerPartial('commentsList', $('#wizardStepDiscussion__commentsList').html());
    },
    afterRender: function (ctx) {
        // Events are bound here
        self.commentTxt = ctx.$el.find(".m-modal__textarea");
        self.commentSendBtn = ctx.$el.parent().find("#m-modal__btn-send");
        self.bindComments(ctx);
    },
    saveComments: function (ctx) {
        var comments = {
            userId: calendarConfiguration.loginUserId,
            comment: self.commentTxt.val(),
            occurrenceId: currentEvent.id
        };
        self.commentSendBtn.attr('disabled', 'disabled');
        ApiClient.createComment(comments)
            .done(function () {
                self.commentTxt.val('');
                self.bindComments(ctx);
            })
            .fail(function (result) {
                var showData = 'An unknown error occured while submitting the comments';
                if (result.responseJSON) {
                    if (result.responseJSON.error && result.responseJSON.error.message) {
                        showData = result.responseJSON.error.message;
                    } else if (result.responseJSON.data) {
                        showData = result.responseJSON.data;
                    }
                }
                ShowErrorPanel(showData);
            })
            .always(function () {
                self.commentSendBtn.removeAttr('disabled');
            });
    },
    bindComments: function (ctx) {
        ApiClient.getComments()
            .done(function (data) {
                ctx.model.comments = data.data;
                var template = Handlebars.partials['commentsList'];
                var $wrapper = ctx.$el.find('.m-modal__step-discussion__list');
                $wrapper.html(template(ctx.model));

                // Resize the iframe and reposition the modal.
                window.performResize();
                window.PositionModal();
            })
            .fail(function (result) {
                var showData = 'An unknown error occured while loading the comments.';
                if (result.responseJSON) {
                    if (result.responseJSON.error && result.responseJSON.error.message) {
                        showData = result.responseJSON.error.message;
                    } else if (result.responseJSON.data) {
                        showData = result.responseJSON.data;
                    }
                }
                ShowErrorPanel(showData);
            })
            .always(function () {
                self.comments = ctx.$el.find(".m-modal__step-discussion__group__comments");
                self.comments.prop('scrollTop', self.comments.prop("scrollHeight"));
            });
    },
    getButtonList: function () {
        return {
            'back': true,
            'sendComment': true
        };
    }
};

// === wizardStepType.js START ====================================================================
